import utils from '../utils/utils';
export const mixin = {
  data() {
    return {
      mixin_uid: '',
      mixin_uname: '',
    };
  },
  created() {
    this.mixin_uid = utils.getUserInfo('id');
    this.mixin_uname = utils.getUserInfo('name');
  },
};
